import { Company, CompanyStatusEnum, DniTypeEnum } from '../../../../models';

export const ACTIONS = {
  NAME: 'NAME',
  EMAIL: 'EMAIL',
  DNI: 'DNI',
  DNI_TYPE: 'DNI_TYPE',
  PHONE: 'PHONE',
  STATUS: 'STATUS',
  DEFAULT: 'DEFAULT',
} as const;

export type ACTIONS_TYPE =
  | { type: 'NAME'; payload: string }
  | { type: 'EMAIL'; payload: string }
  | { type: 'DNI'; payload: string }
  | { type: 'DNI_TYPE'; payload: string }
  | { type: 'PHONE'; payload: string }
  | { type: 'STATUS'; payload: CompanyStatusEnum }
  | { type: 'DEFAULT'; payload: Partial<Company> };

export function reducer(
  state: Partial<Company>,
  action: ACTIONS_TYPE
): Partial<Company> {
  switch (action.type) {
    case ACTIONS.NAME:
      return { ...state, name: action.payload };
    case ACTIONS.EMAIL:
      return { ...state, email: action.payload };
    case ACTIONS.DNI:
      return { ...state, dni: action.payload };
    case ACTIONS.DNI_TYPE:
      return { ...state, dniType: action.payload as DniTypeEnum };
    case ACTIONS.PHONE:
      return { ...state, phone: action.payload };
    case ACTIONS.STATUS:
      return { ...state, status: action.payload };
    case ACTIONS.DEFAULT:
      return { ...state, ...(action?.payload ?? {}) };
    default:
      return { ...state };
  }
}
